// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQ_faqContainer__fC2cN","faqItem":"FAQ_faqItem__2dp4Z","faIcon":"FAQ_faIcon__N6JG-"};